import { GameButtons } from "./GameButtons";

export default GameButtons;
